<!DOCTYPE html>
<template>
	<div>
		<a href="#main-content" class="sr-only sr-only-focusable">Skip to main content</a>
		<main id="main-content">
			<img src="@/assets/brand/secudoc-stacked.svg" alt="SecuDoc" height="180" class="brand-logo" />
			<h1>Login</h1>
			<form @submit.prevent="pressed">
				<fieldset>
					<legend class="sr-only">Login credentials</legend>
					<div class="login">
						<label for="login-email">Email</label>
						<input id="login-email" type="email" v-model="email" placeholder="email" autocomplete="email">
					</div>
					<div class="password">
						<label for="login-password">Password</label>
						<input id="login-password" type="password" v-model="password" placeholder="password" autocomplete="current-password">
					</div>
				</fieldset>
				<button type="submit" :disabled="!email || !password">Login</button>
			</form>
			<div v-if="error" class="error" role="alert" aria-live="assertive">{{error.message}}</div>
		</main>
	</div>
</template>

<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import { logEvent } from '@/firebaseAnalytics';
	export default {
		methods: {
			async pressed() {
				//TODO: add modal screen for possible wait time.
				this.error = "";
				firebase.auth()
					.signInWithEmailAndPassword(this.email, this.password)
					.then(userCredentials => {
						logEvent('login', { method: 'email' });
						return userCredentials.user;
					}).then(currentUser => {
						return currentUser.getIdTokenResult();
					}).then(idToken => {
						/* TODO: 
							- add multi-dashboard (components) for multi-roles
							- for now, focus on 1 role in list
								- 0 > Admin
								- 1 > Org Admin
								- 2 > Professional
						 */

						/*
							if (idToken.claims.roles != undefined) {
								if (idToken.claims.roles.includes(0)) {
									console.log("not yet available");
								} else if (idToken.claims.roles.includes(1)) {
									this.$router.replace({name: "dashboard-org-admin"});
								} else if (idToken.claims.roles.includes(2)) {
									this.$router.replace({name: "dashboard-org-professional"});
								}
							} else {
								this.$router.replace({name: "dashboard-org-admin"});
							}
						*/
						if (idToken.claims.isAdministrator === true) {
							this.$router.replace({name: "dashboard-admin"});
						} else if (idToken.claims.isOrgAdministrator === true) {
							this.$router.replace({name: "dashboard-org-admin"});
						} else if (idToken.claims.isProfessional === true) {
							this.$router.replace({name: "dashboard-org-professional"});
						} else {
							console.warn("has no user claims, defaulting to admin for the meantime");
							this.$router.replace({name: "dashboard-admin"});
						}
						return;
					}).catch(error => {
						console.error(error);
						this.error = error;
					});
			}
		},
		data() {
			return {
				email: "",
				password: "",
				error: null
			}
		}
	
	}
</script>

<style lang="scss" scoped>
.brand-logo {
	margin-bottom: var(--secudoc-space-5);
}
main {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: var(--secudoc-space-6);
}
h1 {
	text-align: center;
	margin-bottom: var(--secudoc-space-5);
}
form {
	width: 100%;
	max-width: 26rem;
}
.error {
	color: var(--secudoc-error);
	font-size: 1rem;
	font-weight: 500;
}
input {
	width: 100%;
	max-width: 25rem;
	padding: var(--secudoc-space-5);
	margin: var(--secudoc-space-4);
	font-size: 1rem;
}
button {
	width: 100%;
	max-width: 25rem;
	height: var(--secudoc-space-7);
	font-size: 1rem;
	min-height: var(--secudoc-touch-target);
}
</style>
